<template>
  <div class="header">
    <el-menu
      :default-active="currentPath"
      class="header-menu"
      mode="horizontal"
      @select="handleSelect"
      background-color="#085484"
      text-color="#fff"
      active-text-color="#ffd04b"
    >
      <el-menu-item index="/home">Home</el-menu-item>
      <el-menu-item index="/Products">Products</el-menu-item>
      <el-menu-item index="/aboutUs">About Us</el-menu-item>
      <el-menu-item index="/contactUs">Contact Us</el-menu-item>
    </el-menu>
  </div>
</template>


<script>
export default {
  name: "Header",
  computed: {
    currentPath() {
      return this.$route.path; // 获取当前路由的路径
    },
  },
  data() {
    return { activeIndex: "/home" };
  },
  methods: {
    handleSelect(key) {
      this.$router.push(key);
    },
  },
};
</script>

<style lang="less" scoped>
.header {
  .header-menu {
    box-sizing: border-box;
    width: 100%;
    padding: 8px 0;
    padding-left: 200px;
    ::v-deep.el-menu--horizontal > .el-menu-item {
      height: 40px;
      line-height: 40px;
    }
    ::v-deep.el-menu--horizontal > .el-submenu .el-submenu__title {
      height: 40px;
      line-height: 40px;
    }
  }
}
</style>
